import axios from "axios";
import { axiosInstance } from "../../../api/axiosInstance.tsx";

const API_URL = process.env.REACT_APP_API_URL + "/auth";

export const registerUser = async (formData: { email: string; username: string; password: string }) => {
  try {
    const response = await axios.post(`${API_URL}/register`, formData, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const loginUser = async (formData: { email: string; password: string }) => {
  try {
    const response = await axios.post(`${API_URL}/login`, formData, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUser = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/user`);
    return response.data;
  } catch (error) {
    throw error;
  }
};